export const getEventId = ({eviteEvent}) => eviteEvent?.id;

export const getEventHostId = ({eviteEvent}) => eviteEvent.host_id;

export const selectHostIds = ({eviteEvent, details}) =>
  details.cohost.email !== eviteEvent.cohost_email1 ? details.host_ids : eviteEvent.host_ids;

export const selectPendingHostIds = ({eviteEvent, details}) =>
  details.cohost.email !== eviteEvent.cohost_email1
    ? details.pending_host_ids
    : eviteEvent.pending_host_ids;

export const selectShortLink = ({eviteEvent}) => eviteEvent.shortlink;

export const selectCustomSharableLink = ({eviteEvent}) => eviteEvent.custom_shareable_link;

export const selectHasGiftCard = ({eviteEvent}) =>
  eviteEvent?.used_as === 'gift_card' && !!eviteEvent?.gift_card_data?.product_config_id;

export const selectGiftCardData = ({eviteEvent}) => eviteEvent?.gift_card_data;
